import { render, staticRenderFns } from "./PaymentsFormDates.vue?vue&type=template&id=42e23745"
import script from "./PaymentsFormDates.vue?vue&type=script&lang=js"
export * from "./PaymentsFormDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports